<template>
    <div>
        <Illustration large image="/static/img/illustrations/account__time-spent.svg"/>
        <div class="notice">
            {{ textContent }}
        </div>
        <button
            class="btn btn__primary btn--block"
            type="button"
            @click="closeModal"
        > {{ $t('ok') | capitalize }}</button>
    </div>
</template>


<script>
    import { mapActions, mapGetters } from 'vuex';

    export default {
        name: 'SessionDurationModal',
        computed: {
            ...mapGetters('ui/modal', [
                'modalData'
            ]),
            textContent() {
                const hours = this.modalData.hoursOnline;
                return `${this.$t('You have been online for {value} minutes', { value: hours * 60 })}`;
            }
        },
        methods: {
            ...mapActions('ui/modal', [
                'closeModal'
            ]),
        }
    };
</script>


<style>
</style>



// WEBPACK FOOTER //
// src/app/modals/modals/notifications/SessionDurationModal.vue